mutation CopyTickerBarToEvent($eventId: ID!, $fromTickerBarId: ID!, $fromEventId: ID) {
  tickerBar: StreamToolsCopyTickerBarToEvent(eventId: $eventId, fromTickerBarId: $fromTickerBarId, fromEventId: $fromEventId) {
    ...TickerBarFields
  }
}

fragment TickerBarBarStyleFields on StreamToolsTickerBarBarStyle {
  bgColor
  opacity
  padTop
  padBottom
  outerPad
  lineHeightPx
  separatorGapPx
  scrollReverse
  dividerMode
  labelGapPx
  labelFontKey
  labelFontWeight
  labelSizePx
  labelColor
  textFontKey
  textFontWeight
  textSizePx
  textColor
  logoOn
  logoUrl
  logoHeightPx
  logoGapPx
  logoEdgePadPx
}

fragment TickerBarFields on StreamToolsTickerBar {
  tickerBarId
  accountId
  eventId
  name
  topMessages {
    id
    label
    labelColor
    text
  }
  bottomMessages {
    id
    label
    labelColor
    text
  }
  style {
    showTopBar
    scrollSpeedPxS
    borderColor
    borderWidth
    gapHeight
    gapColor
    pageBackground
    textGlowPx
    textGlowColor
    top {
      ...TickerBarBarStyleFields
    }
    bottom {
      ...TickerBarBarStyleFields
    }
  }
  version
  createdAt
  updatedAt
}
